var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 18,
    height: 18,
    transform: "translate(255 11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_55",
    "data-name": "Mask Group 55",
    transform: "translate(-255 -11)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(253.714 9.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M10.286,1.286a9,9,0,1,0,9,9,9,9,0,0,0-9-9Zm7.682,8.357h-3.8a9.263,9.263,0,0,1,1.76-4.6,7.676,7.676,0,0,1,2.039,4.6Zm-7.039,0V2.6A7.662,7.662,0,0,1,14.97,4.171a10.456,10.456,0,0,0-2.087,5.472Zm-1.286,0H7.689A10.456,10.456,0,0,0,5.6,4.171,7.662,7.662,0,0,1,9.643,2.6Zm0,1.286v7.039A7.662,7.662,0,0,1,5.6,16.4a10.456,10.456,0,0,0,2.087-5.472Zm1.286,0h1.954A10.456,10.456,0,0,0,14.971,16.4a7.662,7.662,0,0,1-4.042,1.567ZM4.641,5.045A9.263,9.263,0,0,1,6.4,9.643H2.6a7.676,7.676,0,0,1,2.038-4.6ZM2.6,10.929H6.4a9.263,9.263,0,0,1-1.76,4.6,7.676,7.676,0,0,1-2.039-4.6Zm13.326,4.6a9.263,9.263,0,0,1-1.761-4.6h3.8a7.676,7.676,0,0,1-2.038,4.6Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJv);
export default __webpack_public_path__ + "static/media/jv.6a3e873ef70a1e8df58a66d92c15aa8e.svg";
export { ForwardRef as ReactComponent };